
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbRelatorioLgpd extends AppService {
  abstract getListRelatorioDistribuidor(filter: String): Observable<any>;
  abstract getListRelatorioIntegrador(filter: String): Observable<any>;
  abstract getRelatorioDistribuidor(filter: string): Observable<any>;
  abstract getRelatorioIntegrador(filter: string): Observable<any>;
  abstract getTermosUso();
  abstract getPoliticaPrivacidade();
}